export const CODE_LIVRAISON_PAPIER_USA_INTERDITE = "LIVRAISON_PAPIER_USA_INTERDITE";
export const MESSAGE_LIVRAISON_PAPIER_USA_INTERDITE =
  "Les abonnements papier ne peuvent plus être expédiés vers les États-Unis. Vous pouvez choisir un abonnement numérique.";

interface AdresseAbonnement {
  envoyerAdresseDifferente: boolean;
  pays: string | null;
  paysLivraison: string | null;
}

export const getChampPaysLivraisonInterdite = (
  type: "papier" | "numerique",
  adresse: AdresseAbonnement
): "pays" | "paysLivraison" | undefined => {
  if (type !== "papier") return undefined;

  const champ = adresse.envoyerAdresseDifferente ? "paysLivraison" : "pays";
  const pays = (adresse[champ] ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

  // Même liste explicite que CreateDirectAbonnementFromFrontendAction côté API.
  return /^(?:usa?|unitedstates(?:ofamerica)?|etats?unis?(?:damerique)?|etasunis|etatsunnis)$/.test(pays)
    ? champ
    : undefined;
};
